import { render, staticRenderFns } from "./AbsenceReasonForm.vue?vue&type=template&id=3a963701&"
import script from "./AbsenceReasonForm.vue?vue&type=script&lang=js&"
export * from "./AbsenceReasonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports